export const WIKI_TOPIC_SLUGS = [
    "lineas-y-sublineas",
    "productos",
    "variantes",
    "tipos-de-producto",
    "marcas",
    "colecciones",
    "banners",
    "guia-registrar-ropa-o-zapatos",
    "guia-registrar-productos-restaurante",
    "guia-registrar-articulos-personalizables",
    "preguntas-frecuentes",
    "colores-de-tu-catalogo",
    "modo-de-visualizacion",
    "enlaces-personalizados",
    "bloques",
    "logo-redes-y-whatsapp",
    "orden-vs-venta",
    "venta-rapida",
    "orden-ecommerce",
    "venta-en-tienda",
    "opciones-de-venta",
    "calendario-y-despacho",
    "metodos-de-pago",
    "configuracion-logistica",
    "configuracion-de-sistema",
    "carritos",
    "caja",
    "clientes",
    "bodegas",
    "proveedores",
    "tiendas",
    "inventarios",
    "gastos",
    "listas-de-compras",
    "colaboradores",
    "usuarios-y-roles",
    "galeria",
    "blogs",
    "integraciones-api"
];
